export default class Autenticacao {
  usuario?: string;
  senha?: string;
}
